<template>
    <div class="user-profile">
        <v-container>
            <v-row class="mt-5" justify = "center">
                <div class="display-1 font-weight-light">
                    Personal Info
                </div>
            </v-row>
            <v-row class="my-5 caption" justify = "center">
                <h4>Basic info, like your name and photo, that you would like to share with everyone</h4>
            </v-row>
            <v-row dense>
                <v-col cols="12">
                    <v-card class="">
                        <v-card-title class="subtitle-1 black--text mb-0">Profile</v-card-title>
                        <v-card-subtitle class="subtitle-2 info--text">Some basic info</v-card-subtitle>
                        <v-card flat class="">
                            <!-- upload profile picture -->
                            <v-row justify="space-between" class="mx-7">
                                <v-col cols="7">
                                    <v-row dense align="center">
                                        <v-col cols="7">
                                            <p v-if="uploadDoneAvatar" class="red--text">successfully uploaded!</p>
                                            <p v-if="feedbackAvatar" class="red--text">{{feedbackAvatar}}</p>
                                            <v-file-input accept="image/*" @change="onFileSelected" label="Choose your profile picture" class="custom-small-size"></v-file-input>
                                            <v-progress-linear :active="show" v-if="avatarFile" v-model="avatarProgress"></v-progress-linear>
                                        </v-col>
                                        <v-col cols="5">
                                            <v-btn color="white" small depressed @click="uploadToFirebaseStorageAvatar">UPLOAD</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="3" class="">
                                    <v-row justify="center">
                                        <v-avatar size="72" color=#ffee00 class="">
                                            <span v-if="!avatarUrl" class="info--text">Profile</span>
                                            <img
                                                v-if="avatarUrl"
                                                :src="avatarUrl"
                                                alt="avatar"
                                            >
                                        </v-avatar>
                                    </v-row>
                                </v-col>   
                            </v-row>
                            <!-- upload signature -->
                            <v-row justify="space-between" align="center" class="mx-7">
                                <v-col cols="7" class="">
                                    <v-row dense align="center">
                                        <v-col cols="7">
                                            <p v-if="uploadDoneSignature" class="red--text">successfully uploaded!</p>
                                            <p v-if="feedbackSignature" class="red--text">{{feedbackSignature}}</p>
                                            <v-file-input accept="image/*" @change="onFileSelectedS" label="Choose your signature file" class="custom-small-size"></v-file-input>
                                            <v-progress-linear :active="show" v-if="signatureFile" v-model="signatureProgress"></v-progress-linear>
                                        </v-col>
                                        <v-col cols="5" class="">
                                            <v-btn color="white" small depressed @click="uploadToFirebaseStorageSignature">UPLOAD</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="3" class="">
                                    <v-row justify="center">
                                        <span v-if="!signatureUrl" class="primary info--text">
                                            <div class="pa-2">Signature</div>
                                        </span>
                                        <v-img
                                            contain
                                            v-if="signatureUrl"
                                            :src="signatureUrl"
                                            alt="signature"
                                            max-height="50"
                                            class=""
                                        ></v-img>
                                    </v-row>
                                </v-col>   
                            </v-row>
                            <v-row class="mx-9">
                                <v-text-field class="mx-9" label="NAME" v-model="currentUser.name">
                                </v-text-field>  
                            </v-row>
                            <v-row class="mx-9">
                                <v-text-field class="mx-9" label="ROLE" v-model="currentUser.role">
                                </v-text-field>  
                            </v-row>
                            <!-- Update button -->
                            <v-row justify="center" class="my-1">
                                <v-btn small @click="save2UserBasicInfo">Save</v-btn>
                            </v-row>
                            <v-row dense justify="center" class="pb-5">
                                <v-col cols="auto">
                                    <p v-if="feedbackSaved" class="red--text">{{feedbackSaved}}</p>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
/* eslint-disable no-console */
import {storage, auth, db} from '@/fb'

export default {
    name:'UserProfile',
    data () {
        return {
            refreshComponent:0,

            currentUser : {
                uid:null,
                email:null,
                name:null,
            },

            avatarFile:null,
            avatarProgress:0,
            avatarUrl:null,

            signatureFile:null,
            signatureProgress:0,
            signatureUrl:null,

            uploadDoneAvatar:false,
            uploadDoneSignature:false,
            show:true,
            feedbackAvatar:null,
            feedbackSignature:null,
            feedbackSaved:null,
        }
    },
    created(){
        let ref = db.collection('users').where('email','==',auth.currentUser.email)
        ref.get().then(snap=>{
            snap.forEach(doc=>{
                this.avatarUrl = doc.data().avatar
                this.currentUser.name = doc.data().name
                this.currentUser.role = doc.data().role
                this.signatureUrl = doc.data().signature
            })
        })
    },
    computed:{

    },
    methods:{
        onFileSelected(event){
            this.avatarFile = event
            console.log(event)
            console.log(typeof(event))
        },
        onFileSelectedS(event){
            this.signatureFile = event
        },
        uploadToFirebaseStorageAvatar(){

            var fileAvatar = this.avatarFile;

            if(fileAvatar === null){
                this.feedbackAvatar = "Please select your profile picture first!"
            }

            var metadata = {
                contentType: fileAvatar.type,
            };

            var storageRef = storage.ref();

            //upload to firebase storage
            var uploadTask = storageRef.child('avatars/' + fileAvatar.name).put(fileAvatar,metadata);
            uploadTask.on('state_changed', snapshot=>{
                this.avatarProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                if(this.avatarProgress == 100){
                    this.uploadDoneAvatar = true;
                    this.feedbackAvatar = null;
                    setTimeout(()=>{
                    this.uploadDoneAvatar = false;
                    },2000)
                }
            }, err=>{
                console.log(err)
            }, ()=>{
                uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                    var user = auth.currentUser.uid
                    db.collection('users').doc(user).set({
                        avatar: downloadURL
                    },{ merge: true })
                });
            });
        },
        uploadToFirebaseStorageSignature(){

            var fileSignature = this.signatureFile;

            if(fileSignature === null){
                this.feedbackSignature = "Please select your signature picture first!"
            }

            var metadata = {
                contentType: fileSignature.type,
            };

            var storageRef = storage.ref();

            //upload to firebase storage
            var uploadTask = storageRef.child('signatures/' + fileSignature.name).put(fileSignature,metadata);
            uploadTask.on('state_changed', snapshot=>{
                this.signatureProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                if(this.signatureProgress == 100){
                    this.uploadDoneSignature = true;
                    this.feedbackSignature = null;
                    setTimeout(()=>{
                    this.uploadDoneSignature = false;
                    },2000)
                }
            }, err=>{
                console.log(err)
            }, ()=>{
                uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                    var user = auth.currentUser.uid
                    db.collection('users').doc(user).set({
                        signature: downloadURL
                    },{ merge: true })
                });
            });
        },
        save2UserBasicInfo(){
            db.collection('users').doc(this.currentUser.uid).set({
                name: this.currentUser.name,
                role: this.currentUser.role,
            },{ merge: true });
            this.feedbackSaved = "Your profile has been updated!"
            setTimeout(()=>{
                    this.feedbackSaved = null;
            },2000)
        }
    }
}
</script>

<style>
    .v-label {
        font-size: 0.8em;
    }
    p {
        font-size: 0.8em;
    }
</style>